import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

// Bilgilendirme Popup'ı
export const showInfoAlert = (title: string, text: string) => {
    return MySwal.fire({
        title,
        text,
        icon: 'info',
        confirmButtonText: 'Tamam',
    });
};

// Başarı Popup'ı
export const showSuccessAlert = (title: string, text: string) => {
    return MySwal.fire({
        title,
        text,
        icon: 'success',
        confirmButtonText: 'Harika!',
    });
};

// Hata Popup'ı
export const showErrorAlert = (title: string, text: string) => {
    return MySwal.fire({
        title,
        text,
        icon: 'error',
        confirmButtonText: 'Tamam',
    });
};

// Onay Kutusu Popup'ı
export const showConfirmAlert = (
    title: string,
    text: string,
    confirmText: string = 'Evet',
    cancelText: string = 'Hayır'
) => {
    return MySwal.fire({
        title,
        text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: confirmText,
        cancelButtonText: cancelText,
    });
};

// Onay Kutusu Popup'ı 
export const showConfirmAndRedirectAlert = (
    title: string,
    text: string,
    confirmText: string = 'Evet',
    cancelText: string = 'Hayır',
    redirectUrl?: string // Opsiyonel yönlendirme URL'si
) => {
    return MySwal.fire({
        title,
        text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: confirmText,
        cancelButtonText: cancelText,
    }).then((result) => {
        if (result.isConfirmed && redirectUrl) {
            // Onaylanırsa yönlendirme yap
            window.location.href = redirectUrl;
        }
    });
};
